import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

export const printDivider: AbgSxProps = (theme) => ({
  border: `1px solid ${theme.palette.stroke.lowContrast}`,
});

export const closeIconStyling: AbgSxProps = {
  width: '12px',
  height: '12px',
  path: {
    strokeWidth: '1.5px',
  },
};

export const iconWrapperStyling: AbgSxProps = {
  padding: 0,
};

export const dialogActionsStyles: AbgSxProps = {
  padding: {
    sm: '16px 24px',
    xs: '8px 16px',
  },
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const actionButtonStyling: AbgSxProps = (theme) => ({
  width: 'auto',
  minWidth: '80px',
  height: '40px',
  padding: '8px 16px',
  marginLeft: 'auto',
  backgroundColor: theme.palette.action.primary,
});

export const dialogStyling = {
  zIndex: '1301',
  '& .MuiDialog-container': {
    justifyContent: {
      sm: 'center',
      xs: 'flex-end',
    },
    alignItems: {
      sm: 'center',
      xs: 'flex-end',
    },
  },
  '& .MuiDialog-paper': {
    width: {
      sm: '656px',
      xs: '100%',
    },
    margin: {
      sm: 2,
      xs: 0,
    },
  },
};

export const dialogTitleStyling = {
  color: paletteBase.black,
  textTransform: 'capitalize',
  fontWeight: 700,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  lineHeight: '28px',
  padding: {
    xs: 2,
    sm: 3,
  },
  fontSize: {
    xs: '18px',
    sm: '20px',
  },
};

export const dialogContentStyling = {
  padding: {
    sm: 3,
    xs: 2,
  },
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  marginTop: {
    xs: 2,
    sm: 3,
  },
};

export const dialogDescriptionStyling: AbgSxProps = (theme) => ({
  color: theme.palette.neutral['500'],
});
